import React, { useState } from "react";
import { MusicHallStatusFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { BOOKING_STATUS } from "utils/functions/musicHall";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import { Buttons, Inputs } from "components";

const MusicHallStatusForm = ({
  initialValues,
  status,
  bookerName,
  onBack,
  onSubmit,
}) => {
  const isEditableStatus = status === "1" || status === "2";
  // กด Submit แล้วเก็บค่าไว้ก่อน ให้ admin ยืนยันอีกรอบ เพราะส่งอีเมลหาลูกค้าทันที
  const [_confirmValues, _setConfirmValues] = useState(false);

  const schema = yup.object().shape({
    status: yup.string().required("required"),
    // ต้องตรงกับ API adminAdvanchBooking: บังคับยอดทุกสถานะ ยกเว้น 8 (Cancel by Admin)
    // ช่อง type Number ว่างจะส่ง "" มา แปลงเป็น undefined ให้ขึ้น required แทน error ชนิดข้อมูล
    advance_booking_amount: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" || originalValue === null ? undefined : value,
      )
      .typeError("กรุณาใส่ตัวเลข")
      .when("status", {
        is: (status) => status !== "8",
        then: (s) =>
          s.required("กรุณาใส่ยอดจองห้องล่วงหน้า").moreThan(0, "ยอดต้องมากกว่า 0"),
        otherwise: (s) => s.notRequired(),
      }),
  });

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    // สถานะปัจจุบัน (1/2) ไม่อยู่ใน dropdown แล้ว เคลียร์ค่าให้ admin เลือกเองจาก 3 ตัวเลือก
    defaultValues: isEditableStatus
      ? { ...initialValues, status: "" }
      : initialValues,
  });

  const watchStatusField = watch("status");

  return (
    <MusicHallStatusFormStyled>
      <form onSubmit={handleSubmit(_setConfirmValues)}>
        <div className="f_tile">Status</div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                type="Number"
                label={`ใส่ยอดจองห้องล่วงหน้า เพื่อแจ้งลูกค้า${
                  watchStatusField === "8" ? "" : " *"
                }`}
                // placeholder={t('test')}
                errors={errors.advance_booking_amount?.message}
              />
            )}
            name="advance_booking_amount"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Dropdown
                {...field}
                label={"สถานะ"}
                disabled={!isEditableStatus}
                options={
                  isEditableStatus
                    ? [BOOKING_STATUS[2], BOOKING_STATUS[5], BOOKING_STATUS[7]]
                    : BOOKING_STATUS
                }
                placeholder="เลือกสถานะ"
                errors={errors.status?.message}
              />
            )}
            name="status"
            defaultValue=""
          />
        </div>
        {/* 6 = Reject ขอข้อมูลเพิ่ม, 8 = Cancel by Admin - ทั้งคู่ต้องระบุเหตุผลให้ลูกค้าเห็น */}
        {(watchStatusField === "6" || watchStatusField === "8") && (
          <div className="input_wrap">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.TextArea
                  {...field}
                  label={"เหตุผลการยกเลิก"}
                  // placeholder={t('test')}
                  errors={errors.reason_admin_reject?.message}
                />
              )}
              name="reason_admin_reject"
              defaultValue=""
            />
          </div>
        )}
        {/* ลูกค้าเห็นข้อความนี้ที่การ์ดการจองของตัวเอง ส่วน Admin Note ด้านล่างเห็นแค่ภายใน */}
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextArea
                {...field}
                label={"รายละเอียดแจ้งลูกค้า (ลูกค้าจะเห็นข้อความนี้)"}
                errors={errors.admin_customer_message?.message}
              />
            )}
            name="admin_customer_message"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextArea
                {...field}
                label={"Admin Note (เพื่อการสื่อสารภายใน)"}
                // placeholder={t('test')}
                errors={errors.booking_admin_note?.message}
              />
            )}
            name="booking_admin_note"
            defaultValue=""
          />
        </div>

        <div className="action_layout">
          <div className="btn_action_wrap">
            <Buttons.BgStandard theme_gray label="Cancle" onClick={onBack} />
          </div>
          <div className="btn_action_wrap">
            <Buttons.BgStandard theme_purple type="submit" label="Submit" />
          </div>
        </div>
      </form>
      {_confirmValues && (
        <div className="confirm_layout">
          <div
            className="confirm_backdrop"
            onClick={() => _setConfirmValues(false)}
          />
          <div className="confirm_body">
            <div className="confirm_title">ยืนยันส่งอีเมลแจ้งลูกค้า</div>
            <div className="confirm_box">
              <div className="confirm_row">
                <div className="confirm_label">ยอดเงิน</div>
                <div className="confirm_value confirm_amount">
                  {_confirmValues.advance_booking_amount
                    ? `${RenderCommaMoney(
                        _confirmValues.advance_booking_amount,
                      )} บาท`
                    : "-"}
                </div>
              </div>
              <div className="confirm_row">
                <div className="confirm_label">สถานะ</div>
                <div className="confirm_value">
                  {BOOKING_STATUS.find((e) => e.value === _confirmValues.status)
                    ?.label || "-"}
                </div>
              </div>
              {(_confirmValues.status === "6" ||
                _confirmValues.status === "8") && (
                <div className="confirm_row">
                  <div className="confirm_label">เหตุผล</div>
                  <div className="confirm_value">
                    {_confirmValues.reason_admin_reject || "-"}
                  </div>
                </div>
              )}
              {_confirmValues.admin_customer_message && (
                <div className="confirm_row">
                  <div className="confirm_label">แจ้งลูกค้า</div>
                  <div className="confirm_value">
                    {_confirmValues.admin_customer_message}
                  </div>
                </div>
              )}
              <div className="confirm_row">
                <div className="confirm_label">ผู้จอง</div>
                <div className="confirm_value">{bookerName || "-"}</div>
              </div>
            </div>
            <div className="action_layout">
              <div className="btn_action_wrap">
                <Buttons.BgStandard
                  theme_gray
                  label="ยกเลิก"
                  onClick={() => _setConfirmValues(false)}
                />
              </div>
              <div className="btn_action_wrap">
                <Buttons.BgStandard
                  theme_purple
                  label="ยืนยันและส่ง"
                  onClick={() => onSubmit(_confirmValues)}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </MusicHallStatusFormStyled>
  );
};

MusicHallStatusForm.propTypes = {};

export default MusicHallStatusForm;
